const TRANSLATION = {
  buyModal: {
    afterFree: 'तुमच्या फ्री ट्रायल नंतर',
    btn: 'मोफत आजा प्रयत्न करा',
    freeTrial: '3-दिवसीय मोफत प्रायोगिक कालावधी',
    monthLabel: 'महिना',
    selectLabel: 'एक योजना निवडा',
    title: 'सब्स्क्रिप्शन प्लॅन',
    yearLabel: 'वर्ष',
  },
  contact: {
    block1:
      'सानुकूलन, प्रश्ने किंवा सूचनांसाठी, कृपया contact@noam.tools वर आमच्याशी संपर्क साधा. आम्ही त्वरित प्रतिसाद देऊंग.',
    block2: 'Google Apps Extension स्टोअरमध्ये ★★★★★ वर आम्हाला रेट करून आम्हाला समर्थन द्या.',
    block3: 'या एक्स्टेंशनची शेअर करून इतरांना मदत करा:',
    title: 'आमच्याशी संपर्क साधा',
  },
  help: {
    AquickOverviewOfNoam: 'नोमच्या त्वरित आढावा',
    ChatPDF: 'चॅट पीडीएफ',
    ChatPDF2: 'चॅटपीडीएफ',
    FavoritesManagement: 'पसंदीदा व्यवस्थापन',
    Fixedplugin: 'फिक्स्ड प्लगइन',
    Focusing: 'केंद्रित करणे',
    Free: 'मोफत',
    FreeTrialBenefits: 'फ्री ट्रायल फायदे',
    GoWithWikipedia: 'विकिपीडियासोबत जा',
    GoWithYouTube: 'YouTube वर जा',
    HoverTranslation: 'होव्हर भाषांतर',
    Howtouse: 'वापरण्याची पद्धत',
    ImageTranslation: 'प्रतिमा भाषांतर',
    InstantTranslation: 'त्वरित भाषांतर',
    Membership: 'सदस्यत्व',
    NoamHelp: 'नोआम तुम्हाला भाषांतर आणि सारांश तयार करण्यात मदत करतो',
    PDFparallelTranslation: 'पीडीएफ समांतर भाषांतर',
    ParallelTranslation: 'समांतर भाषांतर',
    SkipAllSteps: 'सर्व चरणे स्किप करा',
    Summary: 'सारांश',
    Translation: 'अनुवाद',
    TryItForFree: 'मोफत आजण्याचा प्रयत्न करा',
    Video: 'व्हिडिओ',
    VideoSummary: 'व्हिडिओ सारांश',
    VideoTranslation: 'व्हिडिओ भाषांतर',
    WebSummary: 'वेब सारांश',
    WordSelectionTranslation: 'शब्द निवड प्रतिलेखन',
    benefits: 'आपल्यासाठी लाभे प्रतीक्षारत आहेत!',
    dayFree: '3-दिवसांचा विनामूल्य चाचणी',
    done: 'केले',
    next: 'पुढे',
    pin: 'सुलभ प्रवेशासाठी नोअम पिन करा～～',
    planIsNotExist: 'योजना उपलब्ध नाही',
    startWiki: 'आपण विकिमीडियासह सुरुवात करूया!',
    startYoutube: 'आपण YouTube वरून सुरुवात करूया!',
    try: 'ते आजण्याचा प्रयत्न करा',
    tryNow: 'आता ते कोशिश करा!',
  },
  home: {
    PDFTranslate: {
      desc: 'द्विभाषिक भाषांतर + चॅट पीडीएफ',
      sub1: {
        desc: 'द्विभाषिक वाचनामुळे तुम्हाला मूळ मजकूर आणि भाषांतर एकमेकांच्या शेजारी तुलना करू शकता आणि वाचन कार्यक्षमता सुधारते.',
        title: 'द्विभाषिक वाचन',
      },
      sub2: {
        desc: 'AI विश्लेषण करते आणि सारांश देते, आणि PDF सामग्रीच्या आधारे तुमच्या प्रश्नांची उत्तरे देऊ शकते.',
        title: 'चॅट पीडीएफ',
      },
      sub3: {
        desc: 'अधिक अचूकता आणि कार्यक्षमतेसाठी AI-संचालित PDF भाषांतर.',
        title: 'अचूकता आणि कार्यक्षमता',
      },
      title: 'पीडीएफ भाषांतर',
    },
    aiAssistant: {
      desc: 'वेब भाषांतर अधिक स्मार्ट आणि सोयीस्कर बनवणे',
      panel1: {
        desc: 'द्विभाषिक क्रॉस-रेफरेन्सिंग भाषांतरे तुम्हाला मूळ मजकूराची भाषांतराशी तुलना करण्यास मदत करतात ज्यामुळे तुम्हाला चांगले समजू शकता आणि तुमची वाचन कार्यक्षमता सुधारण्यात मदत होते.',
        title: 'द्विभाषिक भाषांतर',
      },
      panel2: {
        left: {
          desc: 'वेब पृष्ठ ब्राउझ करताना, तुम्हाला भाषांतर करायचे सामग्रीवर होव्हर करा त्याचे भाषांतर पाहण्यासाठी.',
          title: 'होव्हर ट्रान्सलेशन',
        },
        right: {
          desc: 'वेब पृष्ठ ब्राउझ करताना, अनुवाद पाहण्यासाठी तुम्हाला अनुवाद करायचा मजकूर निवडा. ',
          title: 'मजकूर निवड अनुवाद',
        },
      },
      panel3: {
        one: {
          desc: 'कोणत्याही वेळी, कोणत्याही ठिकाणी वेब पृष्ठे आणि व्हिडिओ सामग्री अनुवादित आणि सारांशित करा, सुगम अनुभवासाठी!',
          title: 'पॉइंट आणि क्लिक',
        },
        three: {
          desc: 'AI-चालित मोठे भाषा मॉडेल ट्रान्सलेशनची अचूकता आणि सुसंगतता सुनिश्चित करतात ज्यामुळे वाचन अनुभव सुधारतो.',
          title: 'एआय-चालित',
        },
        two: {
          desc: 'बहुभाषिक पूर्ण कव्हरेज, द्विभाषिक अडथळा-मुक्त वाचन, वन-क्लिक ट्रान्सलेशन - भिन्नता अनुभवा!',
          title: 'अधिक व्यापक आणि सोयीस्कर',
        },
      },
      panel4: {
        tab1: {
          desc: 'तुमचा कार्यक्षमता तज्ञ - ChatGPT वापरून, नोआम युट्यूब व्हिडिओ सामग्रीचे भाषांतर आणि सारांश देतो जेणेकरून तुमचा वेळ वाचतो!',
          key: 'व्हिडिओ',
          title: 'व्हिडिओ भाषांतर आणि सारांश',
        },
        tab2: {
          desc: 'वेब ब्राउझ करताना प्रतिमा अनुवादित करण्यासाठी क्लिक करा.',
          key: 'प्रतिमा',
          title: 'प्रतिमा अनुवाद',
        },
        tab3: {
          desc: 'वेब पृष्ठांमधून त्वरित मुख्य माहिती काढते आणि सारांश प्रदान करते, ज्यामुळे तुमची वाचन कार्यक्षमता वाढते.',
          key: 'वेब',
          title: 'वेब ट्रान्सलेट आणि सारांश',
        },
        tag1: 'सोपे',
        tag2: 'कार्यक्षम',
        tag3: 'सोप्या पणे समजण्यायोग्य',
      },
      title: 'एआय सहाय्यक',
    },
    getStart: 'सुरुवात करा',
    getStartedForFree: 'मोफत सुरुवात करा',
    howItWork: {
      desc: 'नोअम (Noam) एआय मॉडेल्सचे एकत्रीकरण करून वापरकर्त्यांना क्रॉस-लँग्वेज वेब पृष्ठ भाषांतर आणि सारांश, पीडीएफ आणि प्रतिमा भाषांतर, व्हिडिओ भाषांतर आणि सारांश यासाठी बुद्धिमान अनुभव प्रदान करते',
      title: 'हे कसे काम करते',
    },
    lastBlock: { desc: 'सुगम वाचन अनुभवासाठी उत्तम AI भाषांतर' },
    top: {
      desc: 'नोम हा एक विनामूल्य AI ब्राउजर एक्स्टेंशन आहे जो तुम्हाला वेब पृष्ठे, व्हिडिओ आणि PDF सामग्रीचे भाषांतर आणि सारांश तयार करण्यात मदत करतो.\n      नोममध्ये सामील होऊन आणि जादू अनुभवा!',
      title1: 'एक जादू',
      title2: 'एक क्लिक',
    },
    userReviews: {
      desc: 'क्रोम वेब स्टोअरवरील पाच-तारा पुनरावलोकने',
      title: 'वापरकर्ता पुनरावलोकने',
    },
  },
  installTips: {
    btn: 'आता ते आजा',
    text: 'अधिक वैशिष्ट्ये अनलॉक करण्यासाठी "Noam Browser Plugin" स्थापित करा! वेब क्रॉस-रेफरन्सिंग,\n    वेब व्हिडिओ सारांशीकरण आणि आणखी बरेच!',
  },
  locale: {
    af: 'आफ्रीकान्स',
    am: 'अम्हारिक',
    ar: 'अरबी',
    as: 'असमी',
    auto: 'ऑटो डिटेक्ट',
    az: 'अझरबैजानी',
    ba: 'बाश्किर',
    bg: 'बल्गेरियन',
    bn: 'बांगला',
    bo: 'तिबेटी',
    bs: 'बोस्नियन',
    ca: 'कॅटलॅन',
    cs: 'चेक',
    cy: 'वेल्श',
    da: 'डॅनिश',
    de: 'जर्मन',
    dsb: 'लोअर सोर्बियन',
    dv: 'डिवेही',
    el: 'ग्रीक',
    en: 'इंग्रजी',
    es: 'स्पॅनिश',
    et: 'एस्टोनियन',
    eu: 'बास्क',
    fa: 'फारसी',
    fi: 'फिनिश',
    fil: 'फिलिपिनो',
    fj: 'फिजी',
    fr: 'फ्रेंच',
    frCA: 'फ्रेंच (कॅनडा)',
    ga: 'आयरिश',
    gl: 'गॅलिशियन',
    gom: 'कोंकणी',
    gu: 'ગુજરાતી',
    ha: 'हौसा',
    he: 'हिब्रू भाषा',
    hi: 'हिंदी',
    hr: 'क्रोएशियन',
    hsb: 'अपर सोर्बियन',
    ht: 'हैतियन क्रियोल',
    hu: 'हंगेरियन',
    hy: 'आर्मेनियन',
    id: 'इंडोनेशियन',
    ig: 'इग्बो',
    ikt: 'इनुइन्नाक्टुन',
    is: 'आइसलँडिक',
    it: 'इटालियन',
    iu: 'इनुक्टिटुट',
    iuLatn: 'इनुक्टिटुट (लॅटिन)',
    ja: 'जपानी',
    ka: 'જ્યોર્જિયન',
    kk: 'कझाख',
    km: 'ख्मेर',
    kmr: 'कुर्दिश (उत्तरी)',
    kn: 'ಕನ್ನಡ',
    ko: 'कोरियन',
    ku: 'कुर्दिश (मध्य)',
    ky: 'किर्गिज',
    ln: 'लिंगाला',
    lo: 'लाओ',
    lt: 'लिथुआनियन',
    lug: 'गंदा',
    lv: 'लात्वियन',
    lzh: 'चिनी (साहस्त्रिक)',
    mai: 'मैथिली',
    mg: 'मलागासी',
    mi: 'माओरी',
    mk: 'मॅसेडोनियन',
    ml: 'मलयाळम',
    mnCyrl: 'मंगोलियन (सायरिलिक)',
    mnMong: 'मंगोलियन (पारंपारिक)',
    mr: 'मराठी',
    ms: 'मलय',
    mt: 'माल्टीज',
    mww: 'ह्मोंग डॉ',
    my: 'म्यान्मार (बर्मी)',
    nb: 'नॉर्वेजियन',
    ne: 'नेपाली',
    nl: 'डच',
    noSearchLang: 'भाषा समर्थित केलेली नाही',
    nso: 'सेसोथो सा लेबोआ',
    nya: 'न्यान्जा',
    or: 'ओडिया',
    otq: 'क्वेरेतारो ओटोमी',
    pa: 'ਪੰਜਾਬੀ',
    pl: 'पोलिश',
    placeholder: 'शोधा',
    prs: 'दारी',
    ps: 'पाश्तो',
    pt: 'पोर्तुगीज (ब्राझील)',
    ptPT: 'पोर्तुगीज (पोर्तुगाल)',
    ro: 'रोमानियन',
    ru: 'रशियन',
    run: 'रुंडी',
    rw: 'किन्यारवांडा',
    sd: 'सिंधी',
    si: 'सिंहल',
    sk: 'स्लोवाक',
    sl: 'स्लोव्हेनियन',
    sm: 'सामोआन',
    sn: 'शोना',
    so: 'सोमाली',
    sq: 'अल्बेनियन',
    srCyrl: 'सर्बियन (सायरिलिक)',
    srLatn: 'सर्बियन (लॅटिन)',
    st: 'सेसोथो',
    sv: 'स्वीडिश',
    sw: 'स्वाहिली',
    ta: 'तामिळ',
    te: 'तेलुगू',
    th: 'थाई',
    ti: 'टिग्रिन्या',
    tk: 'तुर्कमेन',
    tlhLatn: 'क्लिंगॉन',
    tlhPiqd: 'क्लिंगॉन (pIqaD)',
    tn: 'सेत्सवाना',
    to: 'टोंगन',
    tr: 'तुर्की',
    tt: 'तातार',
    ty: 'ताहिती',
    ug: 'यूइघुर',
    uk: 'ਯੂਕਰੇਨੀ',
    ur: 'उर्दू',
    uz: 'उझबेक (लॅटिन)',
    vi: 'व्हिएतनामी',
    xh: 'झोसा',
    yo: 'योरुबा',
    yua: 'युकाटेक माया',
    yue: 'कॅंटोनीज (पारंपारिक)',
    zh: 'चिनी',
    zhHans: 'चिनी सरलीकृत',
    zhHant: 'चिनी पारंपारिक',
    zu: 'झूलू',
  },
  login: {
    and: 'आणि',
    btn: 'गुगलसह लॉग इन करा',
    btn1: 'आता लॉग इन करा',
    desc: 'अधिक अनुभवे अनलॉक करण्यासाठी लॉग इन करा',
    policy: 'गोपनीयता धोरण',
    terms: 'वापराची अटी',
    tips: 'साइन अप करून, मी सहमत आहे की',
    title: 'नोममध्ये आपले स्वागत आहे',
  },
  pageFooter: {
    follow: { facebook: 'फेसबुक', title: 'अनुसरण करा', twitter: 'ट्विटर' },
    legal: { policy: 'गोपनीयता धोरण', terms: 'सेवा अटी', title: 'कायदेशीर' },
    product: {
      image: 'प्रतिमा अनुवाद',
      pdf: 'पीडीएफ भाषांतर',
      title: 'उत्पादने',
      video: 'व्हिडिओ भाषांतर आणि सारांश',
      web: 'वेब ट्रान्सलेशन आणि सारांश',
    },
    resources: { title: 'संसाधने' },
    tools: { title: 'साधने', pdf: 'पीडीएफ भाषांतर' },
  },
  pageHeader: {
    contact: 'संपर्क',
    help: 'मदत करा',
    logout: 'लॉग आउट',
    logoutSucc: 'लॉग आउट केले आहे.',
    pricing: 'किंमत निर्धारण',
    settings: 'सेटिंग्ज',
    signUp: 'लॉग इन करा',
  },
  pdf: {
    autoDetect: 'ऑटो-डिटेक्ट',
    cancelBtn: 'रद्द करा',
    cancelUpload: 'रद्द करा',
    chatPdf: {
      summaryError: 'सारांश विफल झाला, कृपया नंतर पुन्हा प्रयत्न करा',
      chatError: 'चॅट अयशस्वी झाला, कृपया नंतर पुन्हा प्रयत्न करा',
      Search: 'शोधा',
      cancel: 'रद्द करा',
      chatTitle: 'नोममध्ये स्वागत आहे! तुमच्या पीडीएफचा सारांश येथे आहे:',
      clear: 'स्पष्ट',
      clearContent:
        'हे एक नवीन संभाषण सुरू करेल. सध्याचे संभाषण सेव्ह केले जाणार नाही. तुम्हाला खात्री आहे का?',
      clearDialogTitle: 'कृपया पुष्टी करा',
      clearSucc: 'क्लियर झाले',
      copy: 'कॉपी',
      copySucc: 'कॉपी केले',
      delete: 'हटवा',
      deleteCancel: 'रद्द करा',
      deleteContent:
        'हा PDF हटवल्यावर पुन्हा पुनर्प्राप्त केला जाऊ शकत नाही. तुम्हाला खात्री आहे का?',
      deleteOk: 'हटवा',
      deleteSuccess: 'हटविले गेले',
      deleteTitle: 'हटवणे की पुष्टी करा',
      expand: 'कोलॅप्स',
      historyTitle: 'इतिहास',
      listError:
        'रीडिंग लिस्ट लोड करण्यात अयशस्वी झाले. कृपया नंतर पुन्हा प्रयत्न करा किंवा समर्थनाशी संपर्क साधा. ',
      loading: 'लोड होत आहे...',
      noDataDesc: 'आत्तापर्यंत कोणताही इतिहास नाही.',
      noMore: 'आणखी सामग्री नाही.',
      placeholder: 'या PDF बद्दल काहीही विचारा',
      summaryTitle: 'तुम्हाला या प्रश्नांमध्ये रस असू शकतो:',
    },
    collectionEmpty: 'तुमचा संग्रह रिक्त आहे.',
    collectionTab: 'नोट्स',
    dataLoading: 'लोड होत आहे...',
    dialogContent: 'तुम्हाला याचे हटवणे निश्चित आहे का?',
    dialogTitle: 'कृपया पुष्टी करा',
    download: {
      both: 'द्विभाषिक',
      btn: 'सहेजा',
      cancel: 'हे विंडो बंद केल्यास PDF डाउनलोड रद्द होईल. तुम्हाला खरोखर रद्द करायचे आहे का?',
      desc: 'डिवाइसमध्ये सेव्ह करा: भाषांतरे प्रतिमा म्हणून डाउनलोड करते; सेव्ह करा आणि प्रिंट करा: मूळ फॉर्मॅटमध्ये भाषांतरे डाउनलोड करते, कॉपी सपोर्टसह.',
      download: 'डाउनलोड करा',
      downloadMsg1: 'पीडीएफ भाषांतर प्रगती:',
      downloadMsg2: 'अंदाजित उर्वरित वेळ:',
      downloadSucc: 'पीडीएफ तयार आहे! सेव्ह करण्यासाठी क्लिक करा.',
      downloadTip: 'पीडीएफ डाउनलोड होत आहे. डाउनलोड त्रुटी टाळण्यासाठी हे विंडो बंद करू नका. ',
      error: 'सेव्ह करण्यात अयशस्वी झाले. त्याऐवजी प्रिंट करण्याचा प्रयत्न करा.',
      fileName: 'फाइल नाव:',
      fileType: 'फाइल प्रकार:',
      loading: 'सेव्ह होत आहे...',
      loading2: 'लोड होत आहे...',
      minute: 'मिनिटे...',
      msg1: 'या दस्तऐवजातील काही भाषांतर मूळ मजकूरापेक्षा लांब आहेत आणि डाउनलोड केलेल्या फाइलमध्ये ओव्हरलॅप होऊ शकतात. आम्ही वेबपेजवर वाचण्याची शिफारस करतो.',
      msg2: 'भाषांतर अद्याप पूर्ण झालेले नाही. भाषांतर पूर्ण झाल्यानंतर कृपया डाउनलोड करा.',
      msg3: '2. काही भाषांतर खूप लांब असतात. मजकूर ओव्हरलॅप टाळण्यासाठी वेबपेजवर वाचा.',
      msg4: 'भाषांतर कार्ये प्रगतीपथावर आहेत. ते पूर्ण झाल्यानंतर पुन्हा प्रयत्न करा.',
      progress:
        'पीडीएफ लिप्यंतरण करत आहे. प्रगती: {{progress}}, अंदाजित उर्वरित वेळ: {{minutes}} मिनिटे...',
      save: 'डिव्हाइसवर सेव करा',
      savePrint: 'सेव्ह करा आणि प्रिंट करा',
      success: 'डाउनलोड केले',
      trans: 'केवळ भाषांतर',
      transContinue: 'अनुवाद सुरू ठेवा',
    },
    downloadBtn: 'डाउनलोड',
    dragTipModal: {
      black: 'अंतराळ',
      leftKey: 'डावा बटण',
      ok: 'समजले',
      press: 'प्रेस',
      tips: 'ड्रॅग करून पाहणे',
    },
    entry: 'पीडीएफ',
    fileErrMsg:
      'फाइल वाचणे अयशस्वी झाले. कृपया नंतर पुन्हा प्रयत्न करा किंवा सपोर्टला संपर्क साधा.',
    fileMsg: 'सध्याचा फाइल आकार:',
    fileMsg2: 'कृपया 300MB पेक्षा लहान फाइल अपलोड करा. ',
    freeBannerBtn: 'अपग्रेड',
    freeBannerTips: 'फ्री पीडीएफ भाषांतर मर्यादा पूर्ण झाली',
    guide: {
      placeholder: 'येथे पीडीएफ लिंक पेस्ट करा',
      start: 'अनुवाद सुरू करा',
      text1: 'द्विभाषिक वाचन',
      text2:
        'मूळ मजकूर आणि भाषांतर एकाच बाजूने तुलना करण्यासाठी द्विभाषिकपणे वाचा, तुमची कार्यक्षमता सुधारण्यासाठी.',
      text3: 'तुमच्या PDF शी चॅट करा',
      text4:
        'AI-संचालित विश्लेषण आणि सारांश. तुमच्या PDF बद्दल प्रश्न विचारा, आणि त्वरित उत्तरे मिळवा.',
      text5: 'अचूक आणि कार्यक्षम',
      text6: 'अधिक अचूकता आणि कार्यक्षमतेसाठी AI-संचालित PDF भाषांतर.',
      title1: 'द्विभाषी अनुवाद',
      title2: 'तुमच्या PDF शी चॅट करा',
      toast: '.pdf वर समाप्त होणारी वैध ऑनलाइन पीडीएफ लिंक प्रविष्ट करा',
    },
    hasTransTask: 'अनुवाद कार्य प्रगतिशील आहे. कृपया प्रतीक्षा करा.',
    hoverTrans: 'परिच्छेदांवर होव्हर करून भाषांतर करा',
    initial: 'पीडीएफ भाषांतर करा',
    installText: 'रोजच्या भाषांतरांसाठी तुमचे वन-स्टॉप सोल्यूशन.',
    installText2: 'कृपया प्रथम विस्तार स्थापित करा',
    installTips: 'अधिक PDF भाषांतर आणि सुरळीत वेबसाइट भाषांतरासाठी विस्तार स्थापित करा:',
    kw: 'मुख्य आहार',
    link: 'लिंक',
    listError:
      'पीडीएफ लोड करण्यात अयशस्वी झाले. कृपया नंतर पुन्हा प्रयत्न करा, किंवा समर्थनाशी संपर्क साधा. ',
    memoTotalCount: 'एकूण 1 आयटम',
    new: 'नवीन फाइल',
    noId: 'फाइल आयडी आढळली नाही. ',
    notPdf: 'फक्त पीडीएफ फाइल्स.',
    okBtn: 'हटवा',
    okBtn2: 'समजले',
    original: 'मूळ',
    parallel: 'समांतर',
    parseErrDialogContent:
      'हे पीडीएफ लिंक थेट भाषांतरित केले जाऊ शकत नाही. कृपया पीडीएफ डाउनलोड करा आणि ते भाषांतरासाठी अपलोड करा. ',
    parseErrTips: 'फाइल पार्स करण्यात अयशस्वी',
    parseFileToast:
      'फाइल पार्स करण्यात अयशस्वी झाले. कृपया नंतर पुन्हा प्रयत्न करा किंवा समर्थनाशी संपर्क साधा.',
    pdfLoading: 'पार्सिंग...',
    searchPlaceholder: 'शोधा',
    selectTrans: 'अनुवादासाठी मजकूर निवडा',
    shareBtn: 'सामायिक करा',
    shareBtnText1: 'शेअर लिंक तयार करा',
    shareBtnText2: 'सामायिक सामग्री अपडेट करा',
    shareModal: {
      cancel: 'रद्द करा',
      copy: 'कॉपी',
      copySucc: 'लिंक कॉपी केला',
      custom: 'सानुकूलित करा:',
      errMsg:
        'निवडलेली सामग्री अद्याप पूर्णपणे भाषांतरित केलेली नाही. शेअर करण्यापूर्वी कृपया भाषांतर करा.',
      gen: 'सामायिक करा',
      modify: 'संपादित करा',
      notSupport: 'ही भाषा सध्या समर्थित नाही.',
      page: 'पृष्ठे',
      pageNuErr: 'कृपया वैध पृष्ठ क्रमांक प्रविष्ट करा.',
      range: 'क्षेत्र: ',
      remain: 'उरलेले',
      remain1: 'एकूण अंदाजित वेळ:',
      search: 'शोधा',
      settings: 'सामायिकरण सेटिंग्ज:',
      shareSetting: 'सामायिक सेटिंग्ज',
      shareText: 'शेअर करा',
      shareTips: 'अनुवादित पीडीएफ लिंक तुमच्या मित्रांसोबत शेअर करा:',
      sourceLang: 'पासून:',
      target: 'करण्यासाठी:',
      text1: 'साझा सेटिंग्ज',
      text2: 'शेअर लिंक तयार करा',
      totalPage: 'एकूण 1 पृष्ठ',
      trans: 'अनुवाद',
      translateTips:
        'सुझाव: जर भाषांतरास जास्त वेळ लागत असेल, तर तुम्ही हे विंडो बंद करून नंतर शेअर करू शकता.',
      translating: 'पीडीएफ लिप्यंतरण करत आहे...',
      update: 'शेअर लिंक अपडेट करा',
    },
    shareMsg1: 'शेअर लिंक तयार झाला आहे.',
    shareMsg2: 'सामायिक सामग्री अद्यतन केली गेली आहे.',
    shareMsg3:
      'शेअर लिंक तयार करण्यात अयशस्वी झाले. कृपया नंतर पुन्हा प्रयत्न करा, किंवा सपोर्टाशी संपर्क साधा.',
    shareMsg4:
      'सामायिक सामग्री अपडेट करण्यात अयशस्वी झाले. कृपया नंतर पुन्हा प्रयत्न करा किंवा समर्थनाशी संपर्क साधा.',
    shareTips: 'तुमचे PDF भाषांतर तयार झाले आहे! तुमच्या मित्रांशी ते शेअर करा.',
    start: 'तुमचा मोफत प्रयोग सुरू करा',
    thumbnail: 'सामग्री सूची',
    toast1: 'PDF लोड होत आहे. कृपया नंतर पुन्हा प्रयत्न करा.',
    toast2: 'PDF सामग्री प्रक्रिया केली जात आहे. संवाद सध्या समर्थित नाही.',
    toast3: 'डाउनलोड होत आहे. डाउनलोड पूर्ण झाल्यानंतर पुन्हा प्रयत्न करा. ',
    toolbar: { Adjust: 'समायोजित करा', autoFit: 'ऑटो-फिट' },
    trans: 'अनुवाद',
    transSucc: 'भाषांतर यशस्वी झाले!',
    unLoginToast: 'हे वैशिष्ट्य वापरण्यासाठी लॉग इन करा.',
    uploadBtn: 'अपलोड करा',
    uploadErr:
      'फाइल अपलोड अयशस्वी झाली. कृपया नंतर पुन्हा प्रयत्न करा, किंवा समर्थनाशी संपर्क साधा.',
    uploadErrSignUrl:
      'अपलोड URL मिळविण्यात अयशस्वी झाले. कृपया नंतर पुन्हा प्रयत्न करा, किंवा समर्थनाशी संपर्क साधा. ',
    uploadMsg1: 'तुमचा फाइल इथे ड्रॅग करा आणि ड्रॉप करा.',
    uploadMsg2: 'समर्थित फाइल प्रकार: PDF  |  कमाल फाइल आकार: 300MB',
    uploadMsg3: 'फाइल्स निवडण्यासाठी क्लिक करा किंवा इथे ड्रॅग करून ड्रॉप करा.',
    uploading: 'अपलोड होत आहे',
    uploadingMsg: 'अपलोड होत आहे. कृपया थांबा.',
    uploadingMsg1: 'फाइल अपलोड होत आहे. कृपया नंतर पुन्हा प्रयत्न करा.',
    uploadingMsg2: 'एक फाइल सध्या रूपांतरित केली जात आहे. कृपया नंतर पुन्हा प्रयत्न करा. ',
    uploadingMsg3:
      'रूपांतरण प्रगती विनंती अयशस्वी झाली. कृपया नंतर पुन्हा प्रयत्न करा, किंवा समर्थनाशी संपर्क साधा. ',
    uploadingMsg4:
      'नोमला स्थानिक फाइल्समध्ये प्रवेश मिळत नाही. अनुवादासाठी कृपया मॅन्युअली पीडीएफ अपलोड करा. ',
    uploadingMsg5:
      'फाइल URL प्राप्त करण्यात अयशस्वी झाले. कृपया नंतर पुन्हा प्रयत्न करा किंवा समर्थनाशी संपर्क साधा.',
    video: 'व्हिडिओ',
    vipBannerBtn: 'अपग्रेड',
    vipBannerTips: 'आपण या महिन्याची PDF भाषांतर मर्यादा प्राप्त केली आहे.',
    webTrans: 'पूर्ण क्रॉस-रेफरन्स',
  },
  pricing: {
    FAQ: 'वारंवार विचारले जाणारे प्रश्न (ववप)',
    FQAObj: {
      a1: 'होय, नोआम एक विनामूल्य प्लॅन ऑफर करते जे तुम्ही ताबडतोब वापरू शकता.',
      a2: 'आम्ही तीन सदस्यत्व योजना ऑफर करतो: प्रो, प्रो+ आणि एंटरप्राइज. तुम्ही मासिक किंवा वार्षिक पेमेंट करणे निवडू शकता. वार्षिक बिलिंगमध्ये लक्षणीय बचत होते.',
      a3: 'दोन्ही प्लॅनमध्ये सर्व वैशिष्ट्ये उपलब्ध आहेत. मुख्य फरक किंमतीचा आहे: वार्षिक सदस्यत्वे एकूणच कमी किंमतीचे आहेत. मासिक सदस्यत्वे दर महिन्याला बिल केल्या जातात, तर वार्षिक प्लॅन्स वर्षातून एकदाच बिल केल्या जातात.',
      a4: 'तुमच्या खात्याच्या सेटिंग्जमध्ये तुम्ही कोणत्याही वेळी तुमची सदस्यता रद्द करू शकता.',
      q1: 'काही विनामूल्य योजना आहे का?',
      q2: 'कोणती किंमत तयारी आणि पेमेंट पर्याय उपलब्ध आहेत?',
      q3: 'मासिक सदस्यत्व आणि वार्षिक सदस्यत्वमध्ये काय फरक आहे?',
      q4: 'मी माझी सदस्यता कसे रद्द करू शकतो?',
    },
    around: 'भोवती',
    billedMonthly: 'मासिक बिल केला जातो',
    billedYearly: 'वार्षिक बिल',
    day: 'दिवस',
    desc: 'योजना तुलना करा आणि सर्वोत्तम निवडा',
    detailedCompare: 'योजना तुलना करा',
    discount: '20% ते कमी',
    enterprise: {
      benefit1: 'प्राधान्य ग्राहक समर्थन',
      benefit2: 'अनेक वापरकर्ते',
      benefit3: 'सानुकूल उपाय',
      benefit5: 'समर्पित खाते व्यवस्थापक',
      btn: 'आमच्याशी संपर्क साधा',
      recommendText: 'कस्टम प्लॅन्स (≥3 व्यक्ती)',
      talkToUs: 'संपर्क साधा',
    },
    free: {
      benefit1: 'त्वरित भाषांतर 100 वेळा/दिवस',
      benefit2: 'वेबसाइट भाषांतर आणि सारांश',
      benefit3: '30 प्रतिमा भाषांतरे',
      benefit4: 'व्हिडिओ भाषांतर आणि सारांश',
      benefit5: '10 PDF भाषांतरे',
      benefit6: '५,००० टोकन',
      btn: 'मोफत प्रयत्न करा',
      recommendText: 'मोफत प्रायोग',
    },
    imageTranslation: 'प्रतिमा भाषांतर',
    month: 'महिना',
    monthly: 'मासिक',
    pageTitle: 'किंमत निर्धारण',
    pdf: {
      chat: 'पीडीएफ चॅट क्वेरी',
      maxPage: 'प्रति PDF जास्तीत जास्त पृष्ठे',
      translation: 'पीडीएफ भाषांतर',
    },
    preMonth: 'प्रति महिना',
    pro: {
      benefit1: 'प्राथमिकता ग्राहक समर्थन',
      benefit2: '1,000,000 टोकन/महिना',
      benefit3: 'वेबसाइट भाषांतर आणि सारांश',
      benefit4: '200 प्रतिमा अनुवाद',
      benefit5: 'व्हिडिओ भाषांतर आणि सारांश',
      benefit6: '200 PDF भाषांतरे',
      btn: 'सुरुवात करा',
      recommendText: 'सर्वाधिक लोकप्रिय',
    },
    proPlus: {
      benefit1: 'प्राधान्य ग्राहक समर्थन',
      benefit2: '3,000,000 टोकन/महिना',
      benefit3: 'वेबसाइट भाषांतर आणि सारांश',
      benefit4: '500 प्रतिमा भाषांतरे',
      benefit5: 'व्हिडिओ ट्रान्सलेशन आणि सारांश',
      benefit6: '500 PDF भाषांतरे',
      recommendText: 'सर्वोत्तम मूल्य',
    },
    video: { summary: 'व्हिडिओ सारांश', translation: 'व्हिडिओ ट्रान्सलेशन' },
    web: {
      contrastiveTranslation: 'द्विभाषी अनुवाद',
      dictionaryTranslation: 'निवड प्रसिध्दीकरण',
      hoverTranslation: 'होव्हर ट्रान्सलेशन',
      instantTranslation: 'तत्काल भाषांतर',
      summary: 'वेब पृष्ठ सारांश',
    },
    yearly: 'वार्षिक',
  },
  privacy: {
    block1:
      'नोआम ("नोआम," "आम्ही," "आमचे" किंवा "आम्हाला") तुमच्या गोपनीयतेला आदर करते आणि तुमच्याकडून किंवा तुमच्याबद्दल मिळवलेल्या कोणत्याही माहितीचे संरक्षण करण्यासाठी वचनबद्ध आहे. हे गोपनीयता धोरण तुमच्या वेबसाइट, अॅप्लिकेशन्स आणि सेवा (एकत्रितपणे "सेवा") वापरून वैयक्तिक माहिती गोळा करण्याच्या किंवा वापरण्याच्या आमच्या प्रथांचे वर्णन करते. आमच्या बिझनेस प्रॉडक्ट ग्राहकांच्या वतीने हाताळलेल्या सामग्रीसाठी हे गोपनीयता धोरण लागू होत नाही, जसे की आमचे API. या डेटाचा वापर आमच्या ग्राहक कराराच्या अधीन आहे, जो या उत्पादनांमध्ये प्रवेश आणि वापर समाविष्ट करतो. ',
    block10:
      'आम्ही ऑनलाइन आणि ऑफलाइन वैयक्तिक माहितीला नुकसान, गैरवापर, अनधिकृत प्रवेश, प्रकटीकरण, बदल किंवा शत्रुतापूर्ण कृत्यांपासून संरक्षित करण्यासाठी व्यावसायिकदृष्ट्या वाजवी तांत्रिक, प्रशासकीय आणि संघटनात्मक उपाययोजना लागू करतो. तथापि, कोणतीही इंटरनेट किंवा ईमेल प्रसारण पूर्ण सुरक्षा किंवा अचूकता हमारवता येत नाही. विशेषतः, आमच्याकडे पाठवलेले किंवा आमच्याकडून पाठवलेले ईमेल सुरक्षित असू शकत नाहीत. म्हणून, सेवा किंवा ईमेलाद्वारे आमच्याकडे कोणती माहिती पाठवायची आहे याचा निर्णय घेताना तुम्ही विशेष लक्ष दिले पाहिजे. याव्यतिरिक्त, सेवेतील कोणत्याही गोपनीयता सेटिंग्ज किंवा सुरक्षा उपाययोजनांच्या अडथळ्यांसाठी किंवा तृतीय पक्ष वेबसाइटींच्या सुरक्षा सेटिंग्ज किंवा सुरक्षा उपाययोजनांसाठी आम्ही जबाबदार नाही. आम्ही तुमच्या वैयक्तिक माहिती तितक्या काळासाठी राखू शकतो किती आवश्यक आहे आम्हाला तुम्हाला सेवा प्रदान करण्यासाठी किंवा इतर वैध व्यावसायिक हेतूंसाठी, जसे की विवाद सोडवणे, सुरक्षा आणि सुरक्षा कारणे, किंवा आमच्या कायदेशीर दायित्वांचे पालन करणे. आम्ही वैयक्तिक माहिती किती काळ राखतो हे अनेक घटकांवर अवलंबून असेल, जसे की माहितीचे प्रमाण, स्वरूप, संवेदनशीलता, अनधिकृत वापर किंवा प्रकटीकरणाचे संभाव्य जोखीम, आम्ही माहितीची प्रक्रिया करत असलेली हेतू, आणि इतर कायदेशीर बंधनकारक विचार. ',
    block11:
      'आम्ही या गोपनीयता धोरणाचे वेळोवेळी अद्यतनीकरण करू शकतो. जेव्हा आम्ही तसे करतो तेव्हा, आम्ही या पृष्ठावर अद्यतन केलेली आवृत्ती पोस्ट करू, जोपर्यंत लागू कायद्याने वेगळे आवश्यक नाही.',
    block12:
      'या गोपनीयता धोरणाबद्दल तुमच्याकडे कोणतेही अनुत्तरित प्रश्न किंवा चिंता असल्यास, कृपया आमच्या ग्राहक सेवेला संपर्क साधा. ईमेल:',
    block2: 'आम्ही तुमच्याशी संबंधित खालील वैयक्तिक माहिती ("वैयक्तिक माहिती") गोळा करतो:',
    block3:
      'तुमच्याद्वारे प्रदान केलेली माहिती: जेव्हा तुम्ही आमच्या सेवा वापरण्यासाठी किंवा आमच्याशी संवाद साधण्यासाठी खाते तयार करता तेव्हा, आम्ही खालीलप्रमाणे वैयक्तिक माहिती गोळा करतो:',
    block4:
      'सेवांच्या वापरामुळे आपोआप प्राप्त झालेली वैयक्तिक माहिती: जेव्हा तुम्ही सेवांमध्ये प्रवेश करता, वापरता किंवा संपर्क साधता, तेव्हा आम्हाला तुमच्या प्रवेशाबद्दल, वापराबद्दल किंवा परस्परसंवादाबद्दल खालील माहिती प्राप्त होते ("तांत्रिक माहिती"):',
    block5: 'आम्ही वैयक्तिक माहितीचा वापर खालील हेतूंसाठी करू शकतो:',
    block6:
      'सारांश किंवा व्यक्ती-अनिर्दिष्ट माहिती: व्यक्तिगत माहितीचा पुन्हा वापर ओळखण्याच्या उद्देशाने रोखण्यासाठी आम्ही ती एकत्रित करू शकतो किंवा व्यक्ती-अनिर्दिष्ट करू शकतो आणि अशा माहितीचा वापर आमच्या सेवांच्या परिणामकारकतेचे विश्लेषण करण्यासाठी, आमच्या सेवांमध्ये सुधारणा आणि वैशिष्ट्ये जोडण्यासाठी, संशोधन करण्यासाठी आणि तत्सम उद्देशांसाठी करू शकतो. याव्यतिरिक्त, आम्ही आमच्या सेवा वापरकर्त्यांचे सामान्य वर्तन आणि वैशिष्ट्ये विश्लेषण करू शकतो आणि एकत्रित माहिती तृतीय पक्षांशी सामायिक करू शकतो, अशी एकत्रित माहिती प्रकाशित करू शकतो किंवा ती सामान्यतः उपलब्ध करू शकतो. आम्ही सेवांद्वारे, कुकीजद्वारे आणि या गोपनीयता धोरणामध्ये वर्णन केलेल्या इतर मार्गांद्वारे एकत्रित माहिती गोळा करू शकतो. आम्ही व्यक्ती-अनिर्दिष्ट माहिती अनामी किंवा व्यक्ती-अनिर्दिष्ट स्वरूपात राखून वापरू शकतो, आणि कायद्याने आवश्यक नसल्यास आम्ही अशा माहितीची पुन्हा ओळखण्याचा प्रयत्न करणार नाही. ',
    block7:
      'काही विशिष्ट परिस्थितींमध्ये, कायद्याने आवश्यक न केल्यास, आम्ही तुमची वैयक्तिक माहिती तृतीय पक्षांना तुम्हाला पुढे सूचना दिल्याशिवाय प्रदान करू शकतो:',
    block8:
      'तुमच्या भौगोलिक स्थानावर अवलंबून, युरोपियन इकोनॉमिक एरिया, युनायटेड किंगडम आणि जागतिक स्तरावरील व्यक्तींना त्यांच्या वैयक्तिक माहितीबद्दल काही वैधानिक अधिकार असू शकतात. उदाहरणार्थ, तुमच्याकडे खालील अधिकार असू शकतात:',
    block9:
      'ही सेवा नोमद्वारे संचालित किंवा नियंत्रित न केलेल्या इतर वेबसाइट्सच्या लिंक्स समाविष्ट करू शकते, ज्यामध्ये सोशल मीडिया सेवा ("तृतीय पक्ष वेबसाइट्स") समाविष्ट आहेत. तृतीय पक्ष वेबसाइट्समध्ये तुम्ही शेअर केलेली माहिती या गोपनीयता धोरणाद्वारे नव्हे तर तृतीय पक्ष वेबसाइट्सच्या विशिष्ट गोपनीयता धोरणे आणि सेवा अटींद्वारे नियंत्रित केली जाईल. आम्ही या लिंक्स सोयीसाठी प्रदान करतो आणि या वेबसाइट्सचे आमचे समर्थन किंवा पुनरावलोकन सूचित करत नाही. त्यांच्या गोपनीयता धोरणे आणि अटींबद्दल माहितीसाठी कृपया थेट तृतीय पक्ष वेबसाइट्सशी संपर्क साधा. ',
    subBlock1:
      'अकाउंट माहिती: जेव्हा तुम्ही आमच्या प्लॅटफॉर्मवर अकाउंट तयार करता तेव्हा, आम्ही तुमच्या अकाउंटशी संबंधित माहिती गोळा करतो, ज्यामध्ये तुमचे नाव, संपर्क माहिती, अकाउंट क्रेडेंशियल्स, पेमेंट कार्ड माहिती आणि व्यवहार इतिहास ("अकाउंट माहिती") समाविष्ट आहे.',
    subBlock10: 'सेवा प्रदान करणे, व्यवस्थापित करणे, देखभाल करणे आणि/किंवा विश्लेषण करणे;',
    subBlock11: 'तुमच्याशी संवाद साधणे;',
    subBlock12: 'नवीन उत्पाद आणि सेवा विकसित करणे;',
    subBlock13:
      'फ्रॉड, गुन्हेगारी क्रियाकलाप किंवा आमच्या सेवांचे गलत वापर रोखणे आणि आमच्या आयटी प्रणाली, आर्किटेक्चर आणि नेटवर्क्सची सुरक्षा संरक्षित करणे;',
    subBlock14: 'व्यवसाय हस्तांतरण करणे;',
    subBlock15:
      'कायदेशीर दायित्वे आणि कायदेशीर कार्यवाही पालन करणे, आमचे अधिकार, गोपनीयता, सुरक्षा किंवा मालमत्ता संरक्षित करणे, तसेच आमच्या संलग्न संस्था, तुम्ही किंवा इतर तृतीय पक्षांच्या अधिकारांचे संरक्षण करणे.',
    subBlock16:
      'पुरवठादार आणि सेवा प्रदाते: व्यवसायाच्या कार्यात्मक गरजा पूर्ण करण्यासाठी आणि विशिष्ट सेवा आणि कार्ये करण्यात आम्हाला मदत करण्यासाठी, आम्ही वैयक्तिक माहिती पुरवठादार आणि सेवा प्रदात्यांना प्रदान करू शकतो, ज्यामध्ये होस्टिंग सेवा प्रदाते, क्लाउड सेवा प्रदाते आणि इतर माहिती तंत्र सेवा प्रदाते, ईमेल संप्रेषण सॉफ्टवेअर आणि वेब विश्लेषण सेवा प्रदाते इत्यादि समाविष्ट आहेत. आमच्या कर्तव्ये पार पाडताना हे भागीदार केवळ आमच्या निर्देशानुसार वैयक्तिक माहितीला प्रवेश देतील, ती प्रक्रिया करतील किंवा स्टोअर करतील.',
    subBlock17:
      'व्यवसाय हस्तांतरण: जर आम्ही धोरणात्मक व्यवहारे, पुनर्गठने, दिवाळखोरी, दिवाळखोरी ताब्यात घेणे किंवा सेवा दुसर्‍या प्रदात्याकडे स्थानांतरित करतो (एकत्रितपणे "व्यवहारे"), तर तुमची वैयक्तिक माहिती आणि इतर माहिती व्यवहाराच्या प्रतिपक्षांना आणि व्यवहारात मदत करणाऱ्या इतर पक्षांना योग्य तपासणी दरम्यान सामायिक केली जाऊ शकते आणि इतर मालमत्तांसह व्यवहाराचा भाग म्हणून उत्तराधिकारी किंवा संलग्न कंपनीला हस्तांतरित केली जाऊ शकते.',
    subBlock18:
      'कायदेशीर आवश्यकता: आम्ही तुमची वैयक्तिक माहिती सरकारी प्राधिकरणे, उद्योगातील सहकर्मी किंवा इतर तृतीय पक्षांशी सामायिक करू शकतो, ज्यामध्ये आमच्या सेवांशी तुमची परस्परसंवाद माहिती समाविष्ट आहे, (1) जर कायद्याने आवश्यक असेल किंवा आम्हाला असे वाटेल की कायदेशीर दायित्वे पालन करण्यासाठी अशी कृती आवश्यक आहे; (2) आमच्या अधिकारे किंवा मालमत्तेचे संरक्षण आणि बचाव करण्यासाठी; (3) जर आम्ही एकतर्फे निर्धारित केले की आमच्या अटी, धोरणे किंवा कायदे भंग झाले आहेत; (4) फसवणूक किंवा इतर बेकायदेशीर क्रियाकलापे शोधण्यासाठी किंवा प्रतिबंधित करण्यासाठी; (5) आमची उत्पादने, कर्मचारी किंवा वापरकर्ते किंवा सार्वजनिक सुरक्षा, सुरक्षा, अखंडता संरक्षित करण्यासाठी; किंवा (vi) कायदेशीर दायित्वापासून बचाव करण्यासाठी.',
    subBlock19:
      'तुमची वैयक्तिक माहिती आणि ती कसे प्रक्रिया केली जाते याबद्दलची माहिती प्राप्त करा.',
    subBlock2:
      'आपण आमच्या सेवा वापरता तेव्हा, आम्ही आपल्या इनपुट्स, फाइल अपलोड किंवा आम्हाला दिलेल्या फीडबॅकमधून वैयक्तिक माहिती गोळा करतो ("कंटेंट").',
    subBlock20: 'आमच्या रेकॉर्डमधून तुमच्या वैयक्तिक माहितीचे हटवण्याची विनंती करा.',
    subBlock21: 'तुमची वैयक्तिक माहिती योग्य करा किंवा अद्ययावत करा.',
    subBlock22: 'तुमची वैयक्तिक माहिती तृतीय पक्षाकडे हस्तांतरित करा (डेटा पोर्टेबिलिटी).',
    subBlock23: 'आपल्या वैयक्तिक माहितीची प्रक्रिया कसे केली जाई ते मर्यादित करा.',
    subBlock24:
      'तुमची सहमती मागे घ्या—जेथे आम्ही प्रक्रियेसाठी कायदेशीर आधार म्हणून सहमतीवर अवलंबून असतो, तुम्ही कोणत्याही वेळी तुमची सहमती मागे घेऊ शकता.',
    subBlock25: 'आम्ही तुमच्या वैयक्तिक माहितीच्या प्रक्रियेवर आक्षेप घ्या.',
    subBlock26: 'आमच्या सेवा सुधारणे आणि संशोधन करणे;',
    subBlock3:
      'संवाद माहिती: जर तुम्ही आम्हाला संदेश पाठवले तर, आम्ही तुमचे नाव, संपर्क माहिती आणि तुमच्या संदेशांची सामग्री ("संवाद माहिती") गोळा करू.',
    subBlock4:
      'सोशल मीडिया माहिती: आमच्याकडे इंस्टाग्राम, फेसबुक, मीडियम, ट्विटर, युट्यूब आणि लिंक्डइन सारख्या सोशल मीडिया वेबसाइट्सवर पृष्ठे आहेत. तुम्ही आमच्या सोशल मीडिया पृष्ठांशी संपर्क साधता तेव्हा, तुम्ही आम्हाला देण्याचे निवडलेले वैयक्तिक माहिती, जसे की तुमचे संपर्क तपशील ("सोशल माहिती") आम्ही गोळा करतो. याव्यतिरिक्त, आमच्या सोशल मीडिया पृष्ठे होस्ट करणार्‍या कंपन्या आम्हाला आमच्या सोशल मीडिया क्रियाकलापांबद्दल एकत्रित माहिती आणि विश्लेषण प्रदान करू शकतात.',
    subBlock5:
      'लॉग डेटा: आमच्या सेवा वापरताना तुमच्या ब्राउझरद्वारे आपोआप पाठविलेली माहिती. लॉग डेटामध्ये तुमचा इंटरनेट प्रोटोकॉल (IP) पत्ता, ब्राउझर प्रकार आणि सेटिंग्ज, तुमच्या विनंत्यांची तारीख आणि वेळ, आणि तुम्ही आमच्या वेबसाइटशी कसे संवाद साधता ते समाविष्ट आहे.',
    subBlock6:
      'वापर डेटा: आम्ही सेवेच्या तुमच्या वापराबद्दल स्वयंचलितपणे माहिती गोळा करू शकतो, जसे की तुम्ही जे सामग्री पाहता किंवा परस्परसंवाद करता त्याचे प्रकार, तुम्ही वापरत असलेली वैशिष्ट्ये, तुम्ही घेतलेली क्रिया, तसेच तुमचा वेळ क्षेत्र, देश, प्रवेशाची तारीख आणि वेळ, यूझर एजंट आणि आवृत्ती, संगणक किंवा मोबाइल डिव्हाइस प्रकार, आणि तुमचे संगणक कनेक्शन.',
    subBlock7:
      'डिव्हाइस माहिती: यामध्ये डिव्हाइसचे नाव, ऑपरेटिंग सिस्टीम, डिव्हाइस ओळखकर्ता आणि तुम्ही वापरत असलेला ब्राउझर समाविष्ट आहे. गोळा केलेली माहिती तुम्ही वापरत असलेल्या डिव्हाइसच्या प्रकारावर आणि त्याच्या सेटिंग्जवर अवलंबून असू शकते.',
    subBlock8:
      'कुकीज: आम्ही आमच्या सेवा चालवण्यासाठी, व्यवस्थापित करण्यासाठी आणि तुमचा अनुभव सुधारण्यासाठी कुकीज वापरतो आहोत. "कुकी" ही तुम्ही भेट दिलेल्या वेबसाइटद्वारे तुमच्या ब्राउझरला पाठविलेली माहिती आहे. तुम्ही तुमच्या ब्राउझरला सर्व कुकीज स्वीकारण्यासाठी, सर्व कुकीज नाकारण्यासाठी सेट करू शकता किंवा जेव्हा कुकी प्रदान केली जाते तेव्हा तुम्हाला सूचित करू शकता जेणेकरून तुम्ही प्रत्येक वेळी स्वीकारण्यात येते की नाही हे ठरवू शकता. तथापि, कुकीज नाकारणे तुम्हाला वेबसाइटच्या काही भागांचा किंवा वैशिष्ट्यांचा वापर करण्यापासून प्रतिबंधित करू शकते किंवा त्यांचे प्रदर्शन किंवा कार्यक्षमता प्रतिकूलपणे प्रभावित करू शकते. कुकीजबद्दल अधिक माहितीसाठी, कृपया ऑल अॅबाउट कुकीज (All About Cookies) ला भेट द्या. ',
    subBlock9:
      'अॅनालिटिक्स: आम्ही विविध ऑनलाइन अॅनालिटिक्स उत्पादने वापरू शकतो जे कुकीज वापरतात जे आम्हाला वापरकर्ते आपल्या सेवा कसे वापरतात ते विश्लेषण करण्यात आणि सेवा वापरताना तुमचा अनुभव सुधारण्यात मदत करतात.',
    subTitle1: 'आम्ही गोळा करणारी वैयक्तिक माहिती',
    subTitle2: 'आम्ही वैयक्तिक माहितीचा वापर कसा करतो',
    subTitle3: 'वैयक्तिक माहितीचे प्रकटीकरण',
    subTitle4: 'तुमचे अधिकार',
    subTitle5: 'इतर वेबसाइट्सचे लिंक',
    subTitle6: 'माहितीची सुरक्षा आणि कायमस्वरूप',
    subTitle7: 'गोपनीयता धोरणाचा बदल',
    subTitle8: 'आमच्याशी संपर्क साधण्याचा तरीका',
    title: 'गोपनीयता धोरण',
    updateTime: 'अद्यतनित: 15 मार्च, 2024',
  },
  privacyCollectionPanel: {
    acceptBtn: 'सर्व स्वीकारा',
    text: 'तुमचा अनुभव सुधारण्यासाठी, आम्ही सामग्री आणि सेवा वैयक्तिकृत करण्यासाठी कुकीज वापरतो.',
    title: 'हे वेबसाइट कुकीज वापरते',
  },
  slogen: 'सर्वात सोपा AI सहाय्यक',
  stripe: {
    contact: 'कोणत्याही प्रश्नांसाठी contact@noam.tools वर आमच्याशी संपर्क साधा!',
    fail: {
      btn: 'पुन्हा प्रयत्न करा',
      text1: 'आम्हाला तुमची पेमेंट प्रोसेस करण्यात अक्षम होतो.',
      text2: 'तुमचे कनेक्शन तपासा आणि पुन्हा प्रयत्न करा.',
      title: 'पेमेंट अयशस्वी',
    },
    succ: {
      btn: 'चला जाऊया',
      text1: 'नोममध्ये आपले स्वागत आहे',
      text2: 'आपण सुरुवात करूया!',
      title: 'आभारी आहे',
    },
  },
  terms: {
    block1: 'नोम वापरल्याबद्दल धन्यवाद!',
    block10:
      '(अ) शुल्के आणि बिलिंग. वापरल्या जाणार्‍या किंमत पृष्ठावरील किंमत आणि अटी किंवा आमच्यातील लेखी करारानुसार तुम्हाला सर्व शुल्के ("शुल्के") भरावयाची आहेत. आम्ही बिल जारी केल्यानंतर किंवा पेमेंट प्राप्त झाल्यानंतरही किंमतीतील त्रुटी किंवा चुका सुधारण्याचा अधिकार राखतो आहोत. तुम्ही पूर्ण आणि अचूक बिलिंग माहिती प्रदान कराल, ज्यामध्ये वैध आणि अधिकृत पेमेंट पद्धत समाविष्ट असेल. आम्ही करारानुसार तुमच्या पेमेंट पद्धतीवर नियतकालिकरित्या चार्ज करू, परंतु आम्ही बिलिंग तारीख वाजवीपणे बदलू शकतो. तुम्ही Noam, त्याच्या सहयोगी कंपन्या आणि तृतीय-पक्ष पेमेंट प्रोसेसरला तुमच्या पेमेंट पद्धतीवर चार्ज करण्याचे अधिकृत करता. जर तुमचा पेमेंट अयशस्वी झाला तर, आम्ही तुम्हाला लेखी सूचना देऊ आणि पेमेंट प्राप्त होईपर्यंत सेवेच्या प्रवेशावर निलंबन लावू शकतो. या करारात वेगळ्या प्रकारे निर्दिष्ट केल्याशिवाय, पेमेंट परतफेड करण्यायोग्य नाहीत.',
    block11:
      '(ब) कर. विशेष रूपे न नमूद केल्याशिवाय, शुल्कांमध्ये कोणतेही फेडरल, राज्य, स्थानिक आणि परदेशी कर, शुल्के आणि तत्सम मूल्यांकने ("कर") समाविष्ट नाहीत. तुमच्या खरेदीशी संबंधित सर्व करांची जबाबदारी तुमची आहे, आमच्या निव्वळ उत्पन्नावर आधारित करांचा अपवाद आहे ज्यासाठी आम्ही तुम्हाला बीजक देऊ-well. तुम्ही अशा करांची त्वरित प्राप्ती करण्याचे आणि आम्हाला कायदेशीररित्या वैध गोपनीयता विधाने प्रदान करण्याचे आणि अशा डेटाच्या हाताळणीसाठी आवश्यक संमती घेण्याचे सहमती देताात, आणि तुम्ही आम्हाला हमी देताात की तुम्ही लागू कायद्यानुसार अशा डेटाचे हाताळणी करताात.',
    block12:
      '(c) किमत बदल. आम्ही तुमच्या खात्याद्वारे आणि/किंवा आमच्या वेबसाइटद्वारे तुम्हाला सूचित करून आमच्या किमती बदलू शकतो. किमत वाढ झाल्यास ते पोस्ट केल्यावर त्वरित प्रभावी होईल. कोणत्याही किमत बदलाचा परिणाम बदलाच्या प्रभावी तारखेनंतर तुमच्या खात्याच्या शुल्कांवर लागू होईल.',
    block13:
      '(डी) विवाद आणि उल्टा देय पेमेंट्स. जर तुम्हाला कोणत्याही फी किंवा करांवर विवाद घालायचा असेल, तर बीजक तारखेच्या तीस (30) दिवसांच्या आत contact@noam.tools वर संपर्क साधा.',
    block14:
      'मोफत वापर. मोफत क्रेडिट्स मिळविण्यासाठी तुम्ही अनेक खाती तयार करू शकत नाही. जर आम्हाला आढळले की तुम्ही मोफत क्रेडिट्सचा सद्भावनेने वापर करत नाही तर आम्ही तुम्हाला मानक शुल्क आकारू शकतो किंवा सेवेसाठी प्रवेश प्रदान करणे थांबवू शकतो. ',
    block15:
      'गोपनीयता. तुमच्याकडे नोआमच्या गोपनीय माहितीचा प्रवेश असू शकतो. सेवा वापरण्याच्या उद्देशासाठी, या अटींतर्गत परवानगी असलेल्या गोपनीय माहितीचाच तुम्ही वापर करू शकता. तुम्ही कोणत्याही तृतीय पक्षाला गोपनीय माहिती प्रकट करू नये आणि तुम्ही स्वतःच्या समान गोपनीय माहितीचे संरक्षण करण्याइतकेच किंवा त्याहून अधिक गोपनीय माहितीचे संरक्षण करण्याची जबाबदारी असेल, किमान वाजवी काळजी घेऊन. गोपनीय माहिती म्हणजे नोआमद्वारे गोपनीय म्हणून नामित केलेली किंवा परिस्थितींमध्ये वाजवीपणे गोपनीय मानली पाहिजे अशी गैर-सार्वजनिक माहिती, ज्यामध्ये सॉफ्टवेअर, विनिर्देश आणि इतर गैर-सार्वजनिक व्यावसायिक माहिती समाविष्ट आहे. खालील प्रकारची माहिती गोपनीय माहितीमध्ये समाविष्ट नाही: (1) तुमच्या दोषाशिवाय सार्वजनिकपणे सामान्यपणे उपलब्ध होणारी माहिती; (2) या अटींतर्गत तुम्हाला प्राप्त होण्यापूर्वी तुमच्याकडे गोपनीयतेच्या कोणत्याही बंधनाशिवाय असलेली माहिती; (3) कोणत्याही गोपनीयता बंधनाशिवाय तृतीय पक्षाद्वारे तुम्हाला कायदेशीररित्या प्रकट केलेली माहिती; किंवा (4) तुम्ही गोपनीय माहिती वापरल्याशिवाय स्वतंत्रपणे विकसित केलेली माहिती. कायदा, न्यायालय किंवा इतर सरकारी आदेशानुसार आवश्यक असल्यास तुम्ही गोपनीय माहिती प्रकट करू शकता, परंतु तुम्ही नोआमला वाजवी पद्धतीने पूर्व लेखी सूचना दिली पाहिजे आणि शक्य तितक्या प्रमाणात, प्रकटीकरणाची व्याप्ती मर्यादित करण्यासाठी वाजवी प्रयत्न करणे आवश्यक आहे, ज्यामध्ये प्रकटीकरणाच्या विनंतींच्या विरोधात आम्हाला मदत करणे समाविष्ट आहे.',
    block16:
      '(b) सुरक्षा. सेवेसमध्ये तुमचा प्रवेश आणि वापर संरक्षित करण्यासाठी तुम्ही वाजवी आणि योग्य उपाययोजना लागू करणे आवश्यक आहे. जर तुम्हाला सेवेच्या तुमच्या वापराशी संबंधित कोणतीही दुर्बलता किंवा उल्लंघन आढळले, तर तुम्ही त्वरित नोआमशी संपर्क साधला पाहिजे आणि दुर्बलता किंवा उल्लंघनाचे तपशील प्रदान केले पाहिजेत.',
    block17:
      '((क) वैयक्तिक डेटाची प्रक्रिया. जर तुम्ही वैयक्तिक डेटाची प्रक्रिया करण्यासाठी सेवा वापरत असाल, तर तुम्हाले कायदेशीररित्या पुरेसे गोपनीयता विधाने प्रदान करणे आवश्यक आहे आणि अशा डेटाची प्रक्रिया करण्यासाठी आवश्यक संमती प्राप्त करणे आवश्यक आहे, आणि तुम्ही आम्हाला हमी देता की तुम्ही लागू कायद्यानुसार अशा डेटाचे हाताळणी करता.)}',
    block18:
      'समाप्ती; निलंबन. ही अटी सेवेच्या तुमच्या पहिल्या वापरापासून प्रभावी होईल आणि ती समाप्त होईपर्यंत प्रभावी राहील. सेवा आणि सामग्रीचा वापर बंद करून तुम्ही कोणत्याही कारणास्तव कोणत्याही वेळी या अटी समाप्त करू शकता. आम्ही कोणत्याही कारणास्तव पूर्व सूचनेने या अटी समाप्त करू शकतो. जर तुम्ही कलम 2 (वापराची आवश्यकता), कलम 5 (गोपनीयता, सुरक्षा आणि डेटा संरक्षण), कलम 8 (विवाद निराकरण) किंवा कलम 9 (सामान्य अटी) मध्ये लक्षणीय उल्लंघन केले असेल, किंवा आमच्या नियंत्रणाबाहेरील कोणत्याही तृतीय-पक्ष तंत्रज्ञान प्रदात्याशी आमचे संबंध बदलले गेले असेल, किंवा कायद्याचे पालन करण्यासाठी किंवा सरकारी विनंतींसाठी, आम्ही तुम्हाला सूचित करून ताबडतोब या अटी समाप्त करू शकतो. जर तुम्ही या अटींचे पालन केले नाही, किंवा तुमचा वापर आम्हाला किंवा कोणत्याही तृतीय-पक्षाला सुरक्षा जोखीम निर्माण करतो, किंवा तुमचा वापर फसवणूकी असल्याचा शंका आहे किंवा आम्हाला किंवा कोणत्याही तृतीय-पक्षाला दायित्वाचा भाग पडू शकतो, तर आम्ही सेवेवर तुमचा प्रवेश निलंबित करू शकतो.',
    block19:
      'संप्तीचे परिणाम. संप्तीनंतर, तुम्ही सेवेचा वापर बंद कराल आणि आमच्या निर्देशानुसार त्वरित कोणत्याही गोपनीय माहितीचे परतावा द्याल किंवा नष्ट कराल. या अटींमधील तरतुदी ज्यांचे स्वभावानुसार संप्ती किंवा कालबाह्यत्वानंतरही कायम राहिल्या पाहिजेत, ज्यामध्ये विभाग 3 आणि 5-9 यांचा समावेश आहे परंतु त्यांनी मर्यादित नाही, ते कायम राहील.',
    block2:
      'या वापराच्या अटी नोमच्या सेवांच्या तुमच्या वापरावर लागू होतात, ज्यामध्ये आमचे अॅप्लिकेशन प्रोग्रामिंग इंटरफेस, सॉफ्टवेअर, टूल, डेव्हलपर सेवा, डेटा, दस्तऐवजीकरण आणि वेबसाइट (एकत्रितपणे "सेवा" म्हणून संदर्भित) समाविष्ट आहेत. आमच्या सेवांचा वापर करून, तुम्ही या अटींचे पालन करण्यास सहमत आहात. आमचे गोपनीयता धोरण तुम्हाला स्वतःची वैयक्तिक माहिती कशी गोळा केली जाते आणि वापरली जाते याचे स्पष्टीकरण देते.',
    block20:
      'क्षतिपूर्ती. सेवेच्या तुमच्या वापरामुळे उद्भवणाऱ्या किंवा त्यास संबंधित कोणत्याही दाव्या, नुकसाने आणि खर्चांपासून (वकिलांच्या शुल्कांसह), तुमच्या सामग्री, सेवेशी संबंधित उत्पादने किंवा सेवांच्या तुमच्या वापरामुळे आणि या अटींचे किंवा लागू कायद्याचे तुमचे उल्लंघनामुळे उद्भवणाऱ्या कोणत्याही दाव्या, नुकसाने आणि खर्चांपासून आम्हाला, आमच्या सहयोगी कंपन्यांना आणि आमच्या कर्मचार्‍यांना संरक्षित करण्यास, तुम्ही बचाव कराल, क्षतिपूर्ती द्याल आणि त्यांना निर्दोष ठेवाल.',
    block21:
      '(b) त्यागवचन. सेवा "असा आहे" म्हणून प्रदान केली जाते. कायद्याने परवानगी दिलेल्या मर्यादेपर्यंत, आम्ही आणि आमचे सहयोगी आणि परवानाधारक सेवेबद्दल कोणत्याही प्रकारचे प्रतिनिधित्व किंवा हमी देत नाहीत आणि कोणत्याही हमी देत नाहीत, ज्यामध्ये व्यापारी गुणवत्ता, विशिष्ट हेतूसाठी योग्यता, समाधानकारक गुणवत्ता, उल्लंघन नसल्याची हमी आणि शांत enjoyment, आणि व्यवहाराच्या क्रमामुळे किंवा व्यापाराच्या वापरामुळे उद्भवणारी कोणत्याही हमी समाविष्ट आहेत परंतु त्यापुरते मर्यादित नाही. आम्ही हमी देत नाही की सेवा अनविरत, अचूक किंवा त्रुटी-मुक्त असेल, किंवा कोणतीही सामग्री सुरक्षित, गमावलेली नाही किंवा बदललेली नाही.',
    block22:
      '(c) दायित्वाची मर्यादा. आम्ही, आमचे संलग्न संस्था किंवा आमचे परवानाधारक कोणीही अप्रत्यक्ष, आनुषंगिक, विशेष, परिणामी किंवा दंडात्मक नुकसानांसाठी जबाबदार असणार नाहीत, ज्यामध्ये नफ्याची हानी, प्रतिष्ठेची हानी, वापराची हानी, डेटाची हानी किंवा इतर अमूर्त नुकसाने समाविष्ट आहेत, जरी आम्हाला अशा नुकसानांच्या शक्यतेबद्दल सूचित केले गेले असेल. या अटींतर्गत, आमचे एकूण दायित्व दाव्याच्या आधीच्या बारा (12) महिन्यांमध्ये तुम्ही सेवेला भरलेल्या शुल्कांपेक्षा जास्त होणार नाही किंवा शंभर यूएस डॉलर ($100), जे अधिक असेल. या विभागातील मर्यादा लागू कायद्याने परवानगी दिलेल्या कमाल मर्यादेपर्यंत लागू होतात.',
    block23:
      'अटी आणि सेवांच्या तुमच्या वापरावर युनायटेड स्टेट्सच्या कायद्यांचे नियमन होते, यूएस कॉन्फ्लिक्ट ऑफ लॉज नियमांचा अपवाद वगळता. अॅप्लिकेशनचा तुमचा वापर इतर स्थानिक, राज्य, राष्ट्रीय किंवा आंतरराष्ट्रीय कायद्यांच्या अधीन असू शकतो. या अटींशी संबंधित कोणतीही कायदेशीर कृती किंवा कार्यवाही केवळ युनायटेड स्टेट्सच्या न्यायालयांमध्ये केली जाईल, आणि तुम्ही अशा न्यायालयांच्या वैयक्तिक अधिकार क्षेत्राखाली सामील होण्यास सहमत आहात.',
    block24:
      'पक्षांचे संबंध. नोआम आणि तुम्ही स्वतंत्र कंत्राटदार आहात, आणि दुसर्‍या पक्षाच्या पूर्वीच्या लेखी संमतीशिवाय कोणताही पक्ष दुसर्‍या पक्षाचे प्रतिनिधित्व करण्याची, दुसर्‍या पक्षाला बांधण्याची किंवा दुसर्‍या पक्षासाठी जबाबदाऱ्या स्वीकारण्याची शक्ती नाही.',
    block25:
      'ब्रँड वापर. आमच्या पूर्व लेखी संमतीशिवाय तुम्ही नोआम किंवा त्याच्या कोणत्याही सहयोगी कंपन्यांचे नाव, लोगो, किंवा ट्रेडमार्क वापरू शकत नाही.',
    block26:
      'या अटींमधील कोणतीही तरतूद अवैध, बेकायदेशीर किंवा लागू करण्यायोग्य नसल्याचे निर्धारित केले गेल्यास, उर्वरित तरतुदी पूर्ण प्रभाव आणि परिणामाने कायम राहतील.',
    block3:
      'जर तुमचे वय 18 वर्षांच्या खाली असेल, तर सेवा वापरण्यासाठी तुम्हाला तुमच्या पालकांच्या किंवा कायदेशीर पालकांची परवानगी घेणे आवश्यक आहे. जर तुम्ही दुसर्‍या व्यक्ती किंवा संस्थेच्या वतीने सेवा वापरत आहात, तर तुम्हाला त्यांच्या वतीने या अटींना स्वीकृती देण्यासाठी अधिकृत असणे आवश्यक आहे. खाते नोंदणी करण्यासाठी तुम्हाला अचूक आणि पूर्ण माहिती दिली पाहिजे. तुम्ही तुमच्या संस्थेच्या बाहेरील कोणालाही तुमचे प्रवेश क्रेडेन्शियल किंवा खाते देऊ शकत नाही, आणि तुमच्या क्रेडेन्शियल वापरून केलेल्या सर्व क्रियाकलापांसाठी तुम्ही जबाबदार आहात.',
    block4:
      '(अ) सेवेचा वापर. तुम्ही या अटींनुसार सेवेला प्रवेश घेऊ शकता आणि आम्ही तुम्हाला सेवा वापरण्याचा गैर-अनन्य अधिकार देतो. सेवा वापरताना, तुम्ही या अटींना आणि सर्व लागू कायद्यांचे पालन कराल. आम्ही आणि आमचे संलग्न संस्था सेवेमधील सर्व अधिकार, शीर्षके आणि स्वारस्ये मालक आहेत.',
    block5:
      'फीडबॅक. आम्ही फीडबॅक, टिप्पण्या, कल्पना, सुचना आणि सुधारणा स्वागत करतो. जर तुम्ही असे कोणतेही सामग्री देत असाल, तर आम्ही ते कोणत्याही प्रतिबंधाशिवाय आणि तुमच्याकडून कोणत्याही भरपाईशिवाय वापरू शकतो.',
    block6:
      '(c) निर्बंध. तुम्ही करू शकत नाही: (1) सेवेचा उपयोग अशा प्रकारे करा की इतरांच्या कोणत्याही अधिकारांचे उल्लंघन, चोरी किंवा उल्लंघन होईल; (2) रिव्हर्स इंजिनियर, डीकंपाइल, डिसॅसेंबल, अनुवाद किंवा अन्यथा सेवा मॉडेल्स, अल्गोरिदम आणि सिस्टमचा सोर्स कोड किंवा अंतर्निहित घटक शोधण्याचा प्रयत्न करा (जरी अशा निर्बंधांना लागू कायद्याद्वारे प्रतिबंधित केले गेले असेल तर वगळता); (3) नोआमशी स्पर्धा करणारे मॉडेल विकसित करण्यासाठी सेवेचे आउटपुट वापरा; (4) API द्वारे परवानगी दिल्याशिवाय कोणत्याही स्वयंचलित किंवा प्रोग्रामिंग पद्धतींचा वापर करून सेवेतून डेटा किंवा आउटपुट काढा, ज्यामध्ये स्क्रॅपिंग, वेब हार्वेस्टिंग किंवा वेब डेटा एक्सट्रॅक्शन समाविष्ट आहे; (5) सेवेच्या आउटपुटला कृत्रिमरित्या तयार केलेले म्हणून प्रस्तुत करा जेव्हा ते असे नाही, किंवा अन्यथा आमच्या वापर धोरणांचे उल्लंघन करा; (6) आमच्या पूर्व संमतीशिवाय API की खरेदी करा, विक्री करा किंवा हस्तांतरित करा; किंवा (7) 13 वर्षांच्या वयाखालील मुलांची किंवा डिजिटल संमतीच्या लागू वयाची कोणतीही वैयक्तिक माहिती आम्हाला द्या. तुम्ही आमच्या दस्तऐवजातील कोणत्याही रेट मर्यादा आणि इतर आवश्यकतांचे पालन कराल.',
    block7:
      '(डी) तृतीय-पक्ष सेवा. सेवेशी संबंधित कोणतेही तृतीय-पक्ष सॉफ्टवेअर, सेवा किंवा इतर उत्पादने त्यांच्या स्वतःच्या अटींद्वारे नियंत्रित केली जातात आणि आम्ही तृतीय-पक्ष उत्पादनांसाठी जबाबदार नाही.',
    block8:
      '(क) तुमची सामग्री. तुम्ही सेवेला इनपुट ("इनपुट") प्रदान करू शकता आणि इनपुटच्या आधारे जनरेट केलेले आणि परत केलेले आउटपुट ("आउटपुट") प्राप्त करू शकता (एकत्रितपणे "सामग्री" म्हणून संबोधले जाते). पक्षांमध्ये, आणि लागू कायद्याने परवानगी दिल्यापर्यंत, तुम्ही सर्व इनपुटचे मालक आहात. नोअम सेवा प्रदान करण्यासाठी आणि राखण्यासाठी, लागू कायद्यांचे पालन करण्यासाठी आणि आमच्या धोरणांची अंमलबजावणी करण्यासाठी सामग्रीचा वापर करू शकतो. तुम्ही सामग्रीची जबाबदारी घ्याल, ज्यामध्ये ती कोणत्याही लागू कायद्यांना किंवा या अटींना उल्लंघन करत नाही याची खात्री करणे समाविष्ट आहे.',
    block9:
      '(b) अचूकता. कृत्रिम बुद्धिमत्ता आणि मशीन लर्निंग हे संशोधनाचे वेगाने विकसित होत असलेले क्षेत्र आहेत. आम्ही आमची सेवा अधिक अचूक, विश्वसनीय, सुरक्षित आणि लाभदायक बनवण्यासाठी सतत प्रयत्न करत आहोत. मशीन लर्निंगच्या संभाव्यत्वाच्या स्वरूपामुळे, आमची सेवा वापरल्याने काही प्रकरणांमध्ये चुकीचे आउटपुट होऊ शकतात, जे वास्तविक व्यक्ती, ठिकाणे किंवा तथ्ये अचूकपणे प्रतिबिंबित करू शकत नाहीत. तुमच्या वापराच्या केसच्या आधारे कोणत्याही आउटपुटच्या अचूकतेचे योग्य मूल्यांकन केले पाहिजे, ज्यामध्ये मॅन्युअलरित्या आउटपुट पुनरावलोकन करणे समाविष्ट आहे.',
    subTitle1: 'नोंदणी आणि प्रवेश',
    subTitle10: 'विभाज्यता',
    subTitle2: 'वापराची आवश्यकता',
    subTitle3: 'सामग्री',
    subTitle4: 'फी आणि पेमेंट',
    subTitle5: 'गोपनीयता, सुरक्षा आणि डेटा संरक्षण',
    subTitle6: 'अवधी आणि समाप्ती',
    subTitle7: 'क्षतिपूर्ती; अस्वीकरणे; दायित्वाची मर्यादा',
    subTitle8: 'शासकीय कायदा आणि अधिकार क्षेत्र',
    subTitle9: 'सामान्य अटी',
    title: 'सेवा अटी',
    updateTime: 'अद्यतनित: 15 मार्च, 2024',
  },
  trialModal: {
    btn: 'आता सुरू करा (फक्त $0.99)',
    chat: 'चॅटपीडीएफ',
    desc1: 'तुमच्या चाचणी कालावधीनंतर, तुम्हाला वार्षिक $180 चा शुल्क आकारला जाईल',
    desc2: 'कधीही रद्द करा',
    focus: 'केंद्रित करणे',
    hover: 'होव्हर भाषांतर',
    image: 'प्रतिमा अनुवाद',
    installBtn: 'आता स्थापित करा आणि तुमचा भेट मिळवा',
    memo: 'पसंतीचे व्यवस्थापन',
    pdf: 'पीडीएफ समांतर भाषांतर',
    realtime: 'तत्काल भाषांतर',
    select: 'शब्द निवड अनुवाद',
    title: 'स्वागत भेट',
    trialText: '7-दिवसीय प्रायोगिक कालावधी',
    video: 'व्हिडिओ भाषांतर',
    videoSummary: 'व्हिडिओ सारांश',
    web: 'समांतर भाषांतर',
    webSummary: 'वेब सारांश',
  },
  upgradeModal: {
    btn: 'आत्ताचा अपग्रेड करा',
    chat: {
      free: 'तुम्ही ChatPDF मर्यादेपर्यंत पोहोचला आहे',
      pro: 'आपण या महिन्यासाठी ChatPDF मर्यादेपर्यंत पोहोचले आहेत',
    },
    contactStr: 'पुढील रीसेटची वाट पाहा, किंवा contact@noam.tools वर आमच्याशी संपर्क साधा.',
    limitAlertStr: 'तुमची फ्री प्लॅन मर्यादा पूर्ण झाली आहे. सुरू ठेवण्यासाठी अपग्रेड करा.',
    more: 'योजना पहा',
    pageLimit: { free: 'तुम्ही पीडीएफ पृष्ठ मर्यादेपर्यंत पोहोचला आहे' },
    title: 'स्मरणपत्र',
    upgradeAlertStr: 'तुमची फ्री प्लॅन मर्यादा पूर्ण झाली आहे. सुरू ठेवण्यासाठी अपग्रेड करा.',
    upload: {
      free: 'तुमची PDF भाषांतर मर्यादा पूर्ण झाली आहे',
      pro: 'आपण या महिन्याची PDF भाषांतर मर्यादा प्राप्त केली आहे',
    },
  },
  welfare: {
    newUser: {
      joinBtn: 'आता सामील होणे',
      label: 'नवीन वापरकर्त्याचे लाभ:',
      remain: 'फक्त 30 शिल्लक आहेत',
      text: 'फक्त 100 जागा उपलब्ध! आत्ताच आपली जागा घ्या!',
    },
  },
  aiPdfTranslator: {
    title: 'फ्री AI पीडीएफ ट्रान्सलेटर: कोणत्याही भाषेत तुलनेसह पीडीएफ भाषांतर करा',
    desc: 'AI सह PDF फाइल्स को सहजपणे कोणत्याही भाषेत रूपांतरित करा. मूळ आणि अनुवादित मजकूर एकमेकांच्या बाजूला तुलना करा, वेगवान आणि विनामूल्य.',
    keywords: 'जीपीटी-4、एआय असिस्टंट、भाषांतर、सारांश、फोकस、चॅटपीडीएफ、मेमो、कार्यक्षमता',
    sourceToTarget: {
      title: 'फ्री पीडीएफ ट्रान्सलेशन टूल: {{source}} ला {{target}} मध्ये विनामूल्य भाषांतर करा',
      desc: 'तुमच्या PDF फाइल्सचे कोणत्याही स्त्रोत भाषेतून तुमच्या पसंतीच्या भाषेत विनामूल्यात भाषांतर करा. प्रगतिशील AI द्वारे समर्थित वेगवान, अचूक आणि सुरक्षित PDF भाषांतर.',
    },
    headerIntroduce: {
      title: 'नोअम: केवळ ऑनलाइन भाषांतरापेक्षा जास्त',
      introduce1: {
        title: 'नोअम · पीडीएफ रीडर',
        desc: '✨क्रमांकित भाषांतर + AI प्रश्न-उत्तर. PDF फाइल्सना तुमच्या लक्ष्य भाषेत जलद आणि अचूकपणे भाषांतरित करा. सामग्रीबद्दल मोकळ्या मनाने प्रश्न विचारून तुमच्या PDF फाइल्सची अधिक खोल समज प्राप्त करा. ',
      },
      introduce2: {
        title: 'नोआम · साइड-बाय-साइड भाषांतर विस्तार',
        desc: '👏तुमच्या सर्व वेबपेज ट्रान्सलेशन गरजा सोडवा:',
        detail1: { title: 'वेबपृष्ठ भाषांतर:', desc: 'साइड-बाय-साइड द्विभाषिक दृश्य' },
        detail2: { title: 'शब्द भाषांतर:', desc: 'एक-क्लिक जलद भाषांतर' },
        detail3: { title: 'त्वरित भाषांतर:', desc: 'शब्दे किंवा वाक्ये त्वरित भाषांतरित करा.' },
        detail4: { title: 'प्रतिमा भाषांतर:', desc: 'प्रतिमा बदला अनुवादित असलेल्या प्रतिमांनी.' },
        detail5: {
          title: 'व्हिडिओ ट्रान्सलेशन:',
          desc: 'चांगल्या प्रेक्षणासाठी द्विभाषिक उपशीर्षके.',
        },
        footer: 'अक्लसंगत भाषांतरासाठी अधिक AI-संचालित वाचन वैशिष्ट्ये अनुभवा!',
      },
    },
    subtitle: 'PDF इंटरनेटवर विनामूल्य अनुवाद करा',
    introduce: {
      module1: {
        detail1: {
          title: 'रिअल-टाइम साइड-बाय-साइड पीडीएफ भाषांतर',
          desc1: 'मूळ आणि अनुवादित सामग्री त्वरित, समकालिक, बाजूने-बाजूला लेआउटमध्ये प्रदर्शित करा',
          desc2: 'सिंक्रोनाइझ्ड स्क्रोलिंगसह दोन्ही आवृत्त्या सहजपणे तुलना करा',
          desc3: 'सुसंगत वाचन अनुभवासाठी समान फॉर्मॅटिंग राखा',
        },
        detail2: {
          title: 'अचूक सामग्री संरेखण आणि पडताळणी',
          desc1: 'सोप्या पडताळणीसाठी स्त्रोत आणि अनुवादित मजकूरमधील परिपूर्ण संरेखण',
          desc2: 'सामग्रीचा प्रत्येक विभाग दोन्ही आवृत्त्यांमध्ये तंतोतंत जुळतो',
          desc3: 'विश्वसनीय परिणामांसाठी भाषांतर विसंगती त्वरीत शोधा आणि सोडवा',
        },
      },
      module2: {
        detail1: {
          title: 'ચોક્કસ ભાષાંતરासाठी अनेक प्रगत AI मॉडेल',
          desc1: 'तुमच्या भाषांतर आवश्यकतांशी जुळण्यासाठी अग्रगण्य AI मॉडेल्समधून निवडा',
          desc2: 'विविध दस्तऐवज प्रकार आणि उद्योगांसाठी इष्टतम परिणाम सुनिश्चित करा',
          desc3: 'लवचिक मॉडेल पर्यायहरू प्रत्येक परिस्थितीसाठी सानुकूलित उपाय प्रदान करतात',
        },
        detail2: {
          title: 'प्रत्येक सामग्री प्रकारासाठी प्रगत स्टेजचे AI भाषांतर',
          desc1: 'आमचे शक्तिशाली AI मॉडेल उच्च अचूकता आणि नैसर्गिक भाषा समज सुनिश्चित करते',
          desc2: 'तांत्रिक, शैक्षणिक आणि सर्जनशील दस्तऐवजे सहजपणे हाताळते',
          desc3: 'तुमच्या सर्व भाषांतर गरजांसाठी विश्वसनीय परिणाम देते',
          desc4: 'आदर्श कार्यप्रदर्शनासाठी विविध सामग्री प्रकारांशी बुद्धिमान रुपांतर',
        },
      },
      module3: {
        detail1: {
          title: 'बुद्धिमान दस्तऐवज परस्परसंवाद',
          desc1: 'प्रगतिशील AI चा वापर करून तुमच्या PDF आणि प्रेझेंटेशन फाइल्ससह सहजपणे चॅट करा',
          desc2: 'दस्तऐवजाच्या सामग्रीबद्दल त्वरित प्रश्न पूछा आणि अचूक उत्तरे प्राप्त करा',
          desc3: 'दीर्घ दस्तऐवजांसाठी त्वरीत संक्षिप्त सारांश तयार करा',
        },
        detail2: {
          title: 'डीप कंटेंट विश्लेषण आणि सीमलेस एकत्रीकरण',
          desc1:
            'कुठल्याही क्षेत्रातील महत्त्वाची माहिती काढा आणि AI-संचालित समजून क्लिष्ट डेटाचे विश्लेषण करा',
          desc2: 'तांत्रिक, शैक्षणिक किंवा सर्जनशील सामग्रीमध्ये अंतर्दृष्टी प्राप्त करा',
          desc3:
            'संपूर्ण दस्तऐवज व्यवस्थापन समाधानकाठी आमच्या PDF ट्रान्सलेटरशी अखंडपणे एकत्रित होते',
        },
      },
      module4: {
        detail1: {
          title: 'पीडीएफ ट्रान्सलेशनच्या पलीकडे: ऑल-इन-वन वेबपेज ट्रान्सलेशन सोल्यूशन',
          desc: 'प्रत्येक ऑनलाइन वाचन परिस्थितीसाठी डिझाइन केलेले आमचे शक्तिशाली साइड-बाय-साइड ट्रान्सलेशन एक्स्टेंशन शोधा.',
          desc1:
            'वेबपेज ट्रान्सलेशन: सिंक्रोनाइज्ड साइड-बाय-साइड दृश्यासह द्विभाषी सामग्रीचा आनंद घ्या',
          desc2: 'शब्द भाषांतर: हायलाइट केलेले शब्दे एका क्लिकने त्वरित भाषांतर करा',
          desc3:
            'त्वरित भाषांतर: त्वरित समजून घेण्यासाठी कोणत्याही मजकूर किंवा वाक्याचे तत्काळ भाषांतर करा',
          desc4: 'प्रतिमा अनुवाद: मूळ प्रतिमांना स्वयंचलितपणे अनुवादित आवृत्त्यांनी बदला',
          desc5: 'व्हिडिओ ट्रान्सलेशन: सुधारित अनुभवासाठी द्विभाषिक उपशीर्षकांसह व्हिडिओं पहा',
        },
      },
    },
    question: {
      title: 'वारंवार विचारले जाणारे प्रश्न',
      answer1: {
        title: 'नोम पीडीएफ ट्रान्सलेटर पीडीएफ ट्रान्सलेशनसाठी वापरण्यास मोफत आहे का?',
        content:
          'होय, तुम्ही सिडर पीडीएफ ट्रान्सलेटरसह पीडीएफ फ्री मध्ये ट्रान्सलेट करू शकता! आम्ही 5,000 टोकन्सचा फ्री कोटा देतो, जो बाजारात सामान्यतः आढळणाऱ्या बहुतेक पीडीएफ दस्तऐवजांचे भाषांतर करण्यासाठी पुरेसा आहे. जर तुम्हाला मोठ्या फाइल्सचे भाषांतर करण्याची आवश्यकता असेल किंवा प्रगत सुविधा आवश्यक असतील, तर तुम्ही आणखी अधिक क्षमतेसाठी आमच्या प्रीमियम प्लॅनमध्ये अपग्रेड करणे निवडू शकता. ',
      },
      answer2: {
        title: 'नोम पीडीएफ ट्रान्सलेटर किती अचूक आहे?',
        content:
          'नोआम पीडीएफ ट्रान्सलेटर प्रगतिशील एआय तंत्रज्ञानाचा वापर करून आणि तुमच्या दस्तऐवजांच्या संदर्भाचे सखोल समजून उच्च अचूक भाषांतर प्रदान करतो. कोणतेही स्वयंचलित भाषांतर परिपूर्ण नसले तरी, आमचे बाजूनोबाजूला डिस्प्ले तुम्हाला प्रत्येक भाषांतराचे सहजपणे पुनरावलोकन करण्यास आणि सुधारण्यास अनुमती देते, ज्यामुळे अंतिम परिणाम तुमच्या गुणवत्तेच्या अपेक्षांशी सामंजस्य साधतो. नोआमसह विश्वसनीय आणि अचूक पीडीएफ भाषांतराचा अनुभव घ्या. ',
      },
      answer3: {
        title: 'मी स्कॅन केलेल्या पीडीएफ फाइल्सचे भाषांतर करू शकतो का?',
        content:
          'होय, तुम्ही आमच्या अंगभूत OCR (ऑप्टिकल कॅरेक्टर रेकग्निशन) तंत्रज्ञानाद्वारे स्कॅन केलेले PDF ट्रान्सलेट करू शकता. आमची प्रणाली स्वयंचलितपणे स्कॅन केलेल्या दस्तऐवजे आणि प्रतिमा-आधारित PDF प्रणाल्यांमधून मजकूर काढते, नंतर तुमच्यासाठी सामग्री ट्रान्सलेट करते. यामुळे गैर-संपादन करण्यायोग्य किंवा फक्त प्रतिमा असलेल्या PDF देखील अचूकपणे ट्रान्सलेट केल्या जाऊ शकतात.',
      },
      answer4: {
        title: 'अनुवादाला किती वेळ लागतो?',
        content:
          'भाषांतर वेगवान आणि कार्यक्षम आहे—बहुतेक दस्तऐवजे त्यांच्या लांबी आणि जटिलतेवर अवलंबून सेकंदांतून काही मिनिटांपर्यंत प्रक्रिया केली जातात. उदाहरणार्थ, एक मानक 10-पृष्ठ PDF चे भाषांतर करण्यासाठी सामान्यतः 2 मिनिटांपेक्षा कमी वेळ लागतो. तुमच्या सर्व दस्तऐवज भाषांतर गरजांसाठी वेगवान परिणाम वेळ वापरा!',
      },
      answer5: {
        title: 'मी वाचनासाठी साइड-बाय-साइड दृश्य ठेवू शकतो का?',
        content:
          'होय, तुम्ही नेहमी तुमचे दस्तऐवज बाजूने बाजूला वाचू शकता. हे लेआउट तुम्हाला मूळ आणि भाषांतरित सामग्री सहजतेने तुलना करण्याची परवानगी देते, ज्यामुळे गुळगुळीत आणि कार्यक्षम वाचन अनुभव सुनिश्चित होतो.',
      },
    },
    freeTrial: 'मोफत प्रयोग',
    toLanguage: { title: 'पीडीएफ एआय अनुवाद जोड्या', item: '{{स्रोत}} ते {{लक्ष्य}}' },
  },
  aiPdfTranslate: {
    header: {
      blog: 'ब्लॉग',
      pricing: 'किंमत निर्धारण',
      button: 'आत्ताचे भाषांतर करा',
      features: 'वैशिष्ट्ये',
      faq: 'सामान्य प्रश्ने आणि उत्तरे',
    },
    hero: {
      upload: {
        title: 'तुमचा PDF अपलोड करा',
        max: 'मॅक्स',
        desc: 'किंवा ड्रॅग करा आणि ड्रॉप करा',
        highlight: 'ब्राउझ करण्यासाठी क्लिक करा',
      },
      title: 'फ्री पीडीएफ ट्रान्सलेटर',
      pill: 'AI-संचालित पीडीएफ ट्रान्सलेटर',
      to: 'करण्यासाठी',
      model: 'जीपीटी-4 आणि क्लॉड',
      support: 'ओसीआर समर्थन',
      desc: 'तात्काळ, अचूक भाषांतर जे मूळ लेआउट संरक्षित करतात. नोआम AI OCR आणि साइड-बाय-साइड दृश्ये समर्थित करते.',
      free: 'मोफत चाचणी',
      complete: 'भाषांतर पूर्ण',
      translated: 'नोआम यांनी भाषांतर केले',
    },
    ticker: {
      pdf: 'पीडीएफ भाषांतर',
      format: 'फॉर्मॅट रिटेन्शन',
      multi: 'बहुभाषिक',
      ocr: 'ओसीआर तंत्रज्ञान',
      side: 'एकमेकांच्या बाजूने',
      chat: 'पीडीएफ सह चॅट करा',
      web: 'वेब भाषांतर',
      secure: 'सुरक्षित आणि खाजगी',
    },
    comparison: {
      bad: {
        title: 'मानक भाषांतर',
        head: 'फॉर्मेटिंग आणि संदर्भ गमावले',
        text1: 'त्रुटी: लेआउट खंडित झाला आहे. प्रतिमा चुकीच्या ठिकाणी आहेत.',
        text2: 'मजकूर ओव्हरलॅप होतो आणि फॉन्ट्स सुसंगत नाहीत. वाचणे कठीण आणि अप्रोफेशनल...',
      },
      dump: { title: 'साधा मजकूर डंप' },
      good: {
        title: 'नोम AI अनुवाद',
        tag: 'परिपूर्ण परिणाम',
        sub: 'परिपूर्ण फॉर्मेटिंग, संदर्भ जाणूनबुजून',
      },
      title: 'नोम AI निवडण्याचे कारण काय?',
      desc: 'कॉपी-पेस्ट भाषांतरामुळे त्रास होत असाल तर थांबा. मानक साधने आणि आमच्या AI-संचालित संदर्भ-सजग भाषांतरामधील फरक अनुभवा.',
    },
    showcase: {
      kicker: 'समर्थित दस्तऐवजे',
      title2: 'कोणतीही भाषा',
      title1: 'कोणताही दस्तऐवज',
      carousel1: 'कला',
      carousel2: 'वास्तुकला',
      carousel4: 'औषध',
      carousel3: 'शैक्षणिक जर्नल',
      note: 'तांत्रिक, शैक्षणिक आणि सर्जनशील दस्तऐवजे सहजपणे हाताळा.',
      carousel7: 'करार',
      carousel5: 'वित्त',
      carousel6: 'कायदा',
      carousel8: 'नीती',
    },
    features: {
      big: {
        title: 'प्रगतिस猛进 AI मॉडेल (GPT-4, क्लॉड)',
        desc: 'तुमच्या भाषांतर आवश्यकतांशी जुळण्यासाठी अग्रणी AI मॉडेल्समधून निवडा. विविध दस्तऐवज प्रकारांसाठी इष्टतम परिणाम सुनिश्चित करा. ',
      },
      grid1: {
        title: 'ओसीआर समर्थन',
        desc: 'स्कॅन केलेल्या पीडीएफ आणि प्रतिमांमधून त्वरित मजकूर काढा आणि भाषांतर करा.',
      },
      grid2: {
        title: 'हाय-रेझ एक्सपोर्ट',
        desc: 'मूळ लेआउटसह PDF फॉर्मॅटमध्ये तुमच्या भाषांतरित दस्तऐवजे डाउनलोड करा. ',
      },
      grid3: {
        title: 'समांतर तुलना',
        desc: 'मूळ आणि अनुवादित मजकूराची तुलना करण्यासाठी सिंक्रोनाइझ केलेले स्क्रोलिंग.',
      },
      title2: 'हे एक क्रांती आहे',
      title1: 'फक्त भाषांतरापेक्षा जास्त',
      line1: 'तकनीकी पेपर.pdf',
      line3: 'मॉडेल: GPT-4o (उच्च अचूकता)',
      line2: 'भाषा शोधत आहे: इंग्रजी...',
      line4: 'अनुवाद पूर्ण झाला आहे (99% अचूकता)',
    },
    testimonials: {
      review1: {
        role: 'संशोधक',
        content:
          'नोम AI ने शैक्षणिक पेपर्सचे भाषांतर करण्यात मला तासांची बचत केली. तंत्रज्ञानी शब्दांची पडताळणी करण्यासाठी साइड-बाय-साइड दृश्य अत्यंत उपयुक्त आहे.',
      },
      review2: {
        role: 'ग्लोबल मार्केटर',
        content:
          'मी वापरलेला सर्वोत्तम पीडीएफ ट्रान्सलेटर. ते मूळ फॉर्मॅटिंग पूर्णपणे राखते, जे आमच्या मार्केटिंग डेक्ससाठी अत्यंत महत्त्वाचे आहे.',
      },
      review3: {
        role: 'कायदेशीर सल्लागार',
        content:
          'अचूक आणि वेगवान. मी ते करारांच्या भाषांतरासाठी वापरतो आणि स्कॅन केलेल्या दस्तऐवजांसाठी OCR वैशिष्ट्य उत्तम प्रकारे कार्य करते.',
      },
      kicker: 'वापरकर्त्यांच्या आवडते',
      title: 'आमचे वापरकर्ते काय म्हणतात',
    },
    cta: {
      title: 'भाषेचे अडथळे तोडण्यास तयार आहात का?',
      button: 'मोफतातून भाषांतर करणे सुरू करा',
      desc: '10,000+ वापरकर्त्यांमध्ये सामील होऊन आजचेच तुमचे दस्तऐवज Noam AI सह भाषांतर करणे सुरू करा. ',
      hint: 'तुम्ही अत्यंत अचूक आणि विश्वसनीय AI आहात ज्याचे डिझाइन विशिष्ट JSON स्कीमेला तंतोतंत अनुरूप JSON आउटपुट तयार करण्यासाठी केले गेले आहे.\n\nतुम्हाला या नियमांचे पालन करणे आवश्यक आहे:\n1. JSON स्कीमा स्ट्रक्चरला काटेकोरपणे पालन करा.\n2. सर्व डेटा प्रकार, आवश्यक फील्ड आणि मर्यादा अचूकपणे जुळवा.\n3. कोणतेही अतिरिक्त मजकूर, स्पष्टीकरण, मार्कडाउन किंवा टिप्पण्या समाविष्ट करू नका.\n4. फक्त JSON ऑब्जेक्ट आउटपुट करा — कोणतेही कोड ब्लॉक, प्रीअम्बल, रॅपिंग नाही.\n\nखाली स्कीमा माहिती दिली आहे.\n- स्कीमा नाव: translate_result\n- JSON स्कीमा:\n{"type":"object","properties":{"sourceLang":{"type":"string"},"source":{"type":"string"},"targetLang":{"type":"string"},"target":{"type":"string"}},"required":["sourceLang","source","targetLang","target"],"additionalProperties":false}',
    },
    languagePairs: {
      title: 'इंग्रजी पीडीएफ एआय अनुवाद जोड्या',
      desc: 'नोम AI द्वारे समर्थित लोकप्रिय भाषांतर दिशा',
    },
    footer: { privacy: 'गोपनीयता धोरण', about: 'आमच्याबद्दल', contact: 'सपोर्टशी संपर्क साधा' },
  },
}

export default TRANSLATION
